import { getSdk } from "./sdkService";

// TODO: Add comments
export async function getPaymentMethod(planId) {
  try {
    const sdk = await getSdk();
    const result = await sdk.billingManager.getPaymentMethod(planId);
    return result;
  } catch (error) {
    throw error;
  }
}